@import '../../../constants/spacing.module.less';

.orders-sidebar-section-header-chip {
  display: flex;
  padding: @space-4 @space-8;
  align-items: center;
  gap: @space-8;
  border-radius: 4px;
  background: var(--grey-300);

  font-size: 12px;
  line-height: 16px;
  font-weight: 500;
}
